module.exports = __webpack_public_path__ + "img/photo-12.3c8f70ce.jpg";